export default {
  namespaced: true,
  state: {
    openedCircuits: [],
    openAllCircuits: {},
    markersOnMap: [],
    loadedCircuit: "",
    selectedDevice: ""
  },
  actions: {
    setLoadedCircuit({commit}, circuitUuid) {
      commit("updateLoadedCircuit", circuitUuid);
    },
    setMarkersOnMap({commit}, markers) {
      commit("updateMarkersOnMap", markers);
    },
    setSelectedDevice({commit}, deviceSerial) {
      commit("updateSelectedDevice", deviceSerial);
    },
    clearState({commit}) {
      commit("clearDashboardStates")
    }
  },
  mutations: {
    updateLoadedCircuit(state, circuitUuid) {
      state.loadedCircuit = circuitUuid;
    },
    updateMarkersOnMap(state, markers) {
      state.markersOnMap = markers;
    },
    updateSelectedDevice(state, deviceSerial) {
      state.selectedDevice = deviceSerial;
    },
    clearDashboardStates(state) {
      state.openedCircuits = [];
      state.openAllCircuits = {};
      state.markersOnMap = [];
      state.selectedDevice = ""
      state.loadedCircuit = ""
    }
  }
}
